import { removeEventError } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getRemoveEventError(event) {
      const req = getState().find(({ event: { uuid } }) => uuid === event.uuid);

      return req ? req.error : removeEventError;
    },
    isRemoveEventRequestFailure(event) {
      const state = getState().find(
        ({ event: { uuid } }) => uuid === event.uuid,
      );

      return state ? state.request.isFailure : false;
    },
    isRemoveEventRequestPending(event) {
      const state = getState().find(
        ({ event: { uuid } }) => uuid === event.uuid,
      );

      return state ? state.request.isPending : false;
    },
    isRemoveEventRequestSuccess(event) {
      const state = getState().find(
        ({ event: { uuid } }) => uuid === event.uuid,
      );

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
